import React, { ReactElement, memo, useMemo } from "react";

// internal deps
import { capitalizeFirstLetter, format } from "@swiggy-private/core-ui";
import { CheckboxCard } from "./CheckobxCard";
import { CardPaymentMethodMeta } from "@payment-ui/interfaces/Card";
import { TEXTS } from "@payment-ui/constants/index";

interface CheckboxProps extends CardPaymentMethodMeta {
    isSelected: boolean;
    // Secure Card Checkbox
    saveCard: boolean;
    handleSecureCardClick: (e: React.MouseEvent) => void;
    onSecureCardInfoClick: (e: React.MouseEvent) => void;
}

export const CheckboxWrapper = memo(function SaveCard(props: CheckboxProps): ReactElement | null {
    const {
        isSecured = false,
        tokenizeSupport = false,
        cardBrand,
    } = props;

    const showSecureCardCheckBox = useMemo((): boolean => tokenizeSupport && !isSecured && props.isSelected, [
        isSecured,
        tokenizeSupport,
        props.isSelected,
    ]);

    const infoCtaText = useMemo(() => {
        return format(TEXTS.SECURE_YOUR_CARD_WITH_VISA_WITH_BRAND, capitalizeFirstLetter(cardBrand));
    }, [cardBrand]);

    return showSecureCardCheckBox ? (
        <CheckboxCard
            infoCtaText={infoCtaText}
            onCheckboxClick={props.handleSecureCardClick}
            onCheckboxCardInfoClick={props.onSecureCardInfoClick}
            pretick={props.saveCard}
        />
    ) : null;
});
